const initialState = {
  userSummary: {},
  misc: {},
  widgets: {},
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case "@@learnerHome/SET_DATA":
      return { ...payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/frontend/store/reducers/learner-home.js